import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.meta && _vm.meta.total > 0 && _vm.noPagination)?_c(VChip,{staticClass:"my-0 mt-1",class:[
    _vm.chipClass,
    {
      glass: _vm.glassActive,
      'grey--text': !_vm.glassActive,
      'text--darken-3': !_vm.glassActive,
    } ],attrs:{"color":_vm.color,"dark":"","x-small":"","data-total":_vm.meta.total}},[_vm._v(_vm._s(((_vm.$t("comuns.showing")) + " " + (_vm.meta.total) + " " + (_vm.$t("comuns.results")))))]):(_vm.meta && _vm.meta.total > 0)?_c(VChip,{staticClass:"my-0 mt-1",class:[
    _vm.chipClass,
    {
      glass: _vm.glassActive,
      'grey--text': !_vm.glassActive,
      'text--darken-3': !_vm.glassActive,
    } ],attrs:{"color":_vm.color,"dark":"","x-small":"","data-total":_vm.meta.total}},[_vm._v(_vm._s(((_vm.$t("comuns.showing")) + " " + (_vm.type === "interval" ? _vm.meta.from ? _vm.meta.to - _vm.meta.from + 1 : 0 : _vm.meta[_vm.sumProperty]) + " " + (_vm.$t("comuns.of")) + " " + (_vm.meta.total) + " " + (_vm.$t("comuns.results")))))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }